<template>
  <div class="p-detail-wrapper">
    <template v-for="productObj in insProducts" :key="productObj.ID">
      <div
        v-if="isInsuredProduct(personId, productObj.ID)"
        :class="'p-detail__block --' + productObj.ID"
      >
        <h3 class="p-detail__heading" v-html="productObj.TITLE"></h3>
        <ul class="p-detail__list">
          <li
            v-for="condition in productObj.CONDITIONS"
            :key="condition.ID"
            class="p-detail__item"
          >
            <template v-if="condition.OPTIONS === undefined">
              <dl v-if="isSelectedCondition" class="p-detail__dl">
                <dt class="p-detail__dt">{{ condition.NAME }}</dt>
                <dd>{{ getCondition(productObj, condition.ID) }}</dd>
              </dl>
            </template>
            <template
              v-else
              v-for="(option, index) in condition.OPTIONS"
              :key="option.ID"
            >
              <dl class="p-detail__dl">
                <dt class="p-detail__dt">
                  {{ index === 0 ? condition.NAME : "&nbsp;" }}
                </dt>
                <dd>
                  {{ getConditionOption(productObj, condition.ID, option.ID) }}
                </dd>
              </dl>
            </template>
          </li>
        </ul>
        <div class="p-detail__fee">
          <p class="p-detail__fee__title">毎月の保険料</p>
          <p class="c-price p-detail__fee__price">
            {{ priceFormat(subtotal(productObj.ID)) }}<span>円／月</span>
          </p>
        </div>
        <p class="p-detail__edit" @click="move('options')">修正する</p>
      </div>
    </template>
  </div>
</template>

<script>
import {
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
} from "@/const.js";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: "ResultBody",
  components: {},
  props: { pid: String },
  data() {
    return {
      personId: this.pid,
    };
  },
  computed: {
    ...mapGetters([
      "getPerson",
      "getPrice",
      "getOptionPrice",
      "getValueFromLabel",
      "isInsuredProduct",
      "isSelectedCondition",
      "priceFormat",
    ]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    insProducts() {
      return INS_PRODUCTS_LABELS;
    },
    getCondition() {
      return (pro, name) => {
        return this.getPerson(this.personId).options[pro.ID][name];
      };
    },
    getConditionOption() {
      return (pro, name, opt) => {
        return this.getPerson(this.personId).options[pro.ID][name][opt];
      };
    },
    thePerson() {
      return this.getPerson(this.personId);
    },
    subtotal() {
      return (product) => {
        let sum = 0;
        this.insProducts
          .find((pro) => pro.ID === product)
          .CONDITIONS.forEach((con) => {
            if (con.OPTIONS === undefined) {
              sum += this.getPrice(
                product + "-" + con.ID,
                this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
                this.thePerson.age,
                this.getValueFromLabel(
                  product + "-" + con.ID === "seimei-course" &&
                    (this.personId === "p3" || this.personId === "p4")
                    ? con.LABELS_CHILD
                    : con.LABELS,
                  this.thePerson.options[product][con.ID]
                ),
                this.personId
              );
            } else {
              let values = [];
              con.OPTIONS.forEach((option) => {
                // console.log(this.thePerson.options[product][con.ID][option.ID]);
                values.push(
                  this.getValueFromLabel(
                    option.LABELS,
                    this.thePerson.options[product][con.ID][option.ID]
                  )
                );
              });
              if (values.filter((v) => !!v).length === values.length) {
                sum += this.getOptionPrice(
                  product + "-" + con.ID,
                  this.getValueFromLabel(GENDER_LABELS, this.thePerson.gender),
                  this.thePerson.age,
                  values
                );
              }
            }
          });
        return sum;
      };
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
    // isInsured(pid) {
    //   return this.$store.getters.getPerson(pid).insured;
    // },
    // addHere(pid) {
    //   return pid === this.currentPerson ? " --here" : "";
    // },
    changePerson(pid) {
      this.currentPerson = pid;
    },
  },
};
</script>

<style scoped lang="scss">
.p-detail {
  @include pc {
    margin: 40px 0;
  }
  @include sp {
    margin: 20px 0;
  }
  &__block {
    @include pc {
      margin-bottom: 70px;
    }
    @include sp {
      margin-bottom: 50px;
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__heading {
    font-weight: 800;
    font-size: 20px;
    .--seimei & {
      color: $color-seimei;
    }
    .--seikatsu & {
      color: $color-seikatsu;
    }
    .--shushin & {
      color: $color-shushin;
    }
    .--tsumitate & {
      color: $color-tsumitate;
    }
  }
  &__fee {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 52px;
    padding: 0 18px;
    margin-top: 25px;
    &__title {
      color: $color-text;
      font-size: 12px;
    }
    .--seimei & {
      color: $color-seimei;
      background-color: $color-seimei-bg;
    }
    .--seikatsu & {
      color: $color-seikatsu;
      background-color: $color-seikatsu-bg;
    }
    .--shushin & {
      color: $color-shushin;
      background-color: $color-shushin-bg;
    }
    .--tsumitate & {
      color: $color-tsumitate;
      background-color: $color-tsumitate-bg;
    }
  }
  &__item {
    border-bottom: 1px solid $color-bg-footer;
    margin-top: 15px;
  }
  &__dl {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__dt {
    font-weight: 800;
    font-size: 14px;
    .--seimei & {
      color: $color-seimei;
    }
    .--seikatsu & {
      color: $color-seikatsu;
    }
    .--shushin & {
      color: $color-shushin;
    }
    .--tsumitate & {
      color: $color-tsumitate;
    }
  }
  &__dd {
    font-size: 14px;
  }
  &__edit {
    text-decoration: underline;
    text-align: right;
    margin-top: 10px;
    font-size: 12px;
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  }
}
</style>